import { DatePicker, Input, InputNumber, message, Select, Switch } from 'antd';
import { updateTrainCategory, createTrainCategory } from '@/api';
import { FormModal, UploadImage } from '@/components';
import { ergodicObj, toDateTime } from '@/utils/utils';
import { st_banner } from '@/utils/statetype';
import React, { useState } from 'react';

const { positionObj, typeObj } = st_banner;
function BannderEdit({ visible, data, onChange }) {

  const handleSubmit = async params => {
    console.log("params:", params)
    if (!params) return onChange();
    const { status, video, ...props } = params;

    data.id
      ? await updateTrainCategory({
        body: {
          id: data.id,
          ...params,
          status: status ? 1 : 0,
          video: video || "",
        },
      })
      : await createTrainCategory({
        body: {
          ...props,
          status: status ? 1 : 0,
          video: video || "",
        },
      });
    message.success('操作成功');
    onChange(true);
  };

  const formData = [
    data?.id && {
      name: 'id',
      label: '编号',
      rules: [{ required: false, message: '请输入编号' }],
      render: <InputNumber disabled placeholder="请输入编号" />,
    },
    {
      name: 'name',
      label: '名称',
      rules: [{ required: true, message: '请输入标题' }],
      render: <Input placeholder="请输入标题" />,
    },
  ];

  return (
    <FormModal
      title="在线学习分类"
      visible={visible}
      formData={formData}
      initialValues={data}
      onChange={handleSubmit}
    />
  );
}

export default BannderEdit;
